import { MEDWIKI_NAME } from '../common/common';
import { default_images } from '../common/defaultImages';
import useRedirect from '../components/customHooks/useRedirect';

export const generateProps = (data, redirectTo) => {
  const { question, image, survey_title, title, type_id, survey_id } = data || {};
  let type = data?.type || data?.trending_type || '';
  if (type === 'comp')
    return {
      internalType: 'comp',
      type_id,
      icon: 'flaticon-medwiki',
      title: question,
      image: image,
      contentType: MEDWIKI_NAME,
      fallbackImage: default_images.medwiki,
      onClick: () => redirectTo('MedwikiDetails', type_id, question)
    };
  else if (type === 'video_archive' || type === 'video')
    return {
      internalType: 'archived_video',
      type_id,
      icon: 'flaticon-clinicalvideo',
      title: question,
      image: image,
      contentType: 'Clinical Video',
      fallbackImage: default_images.clinical,
      onClick: () => redirectTo('ClinicalVideoDetails', type_id, question)
    };
  else if (type === 'gr')
    return {
      internalType: 'gr',
      type_id,
      icon: 'flaticon-grandround',
      title: title,
      image: image,
      contentType: 'Grand Round',
      fallbackImage: default_images.gr,
      onClick: () => redirectTo('GrandRoundDetails', type_id, title)
    };
  else if (type === 'survey')
    return {
      internalType: 'survey',
      survey_id: survey_id,
      type_id: survey_id,
      icon: 'flaticon-polls',
      title: survey_title,
      image: image,
      contentType: 'SPQ',
      fallbackImage: data?.category == 'quiz' ? default_images.quiz : default_images.survey,
      onClick: () => redirectTo('SPQdetails', survey_id, survey_title)
    };
  else if (type === 'training') {
    return {
      internalType: 'training',
      type_id,
      icon: 'flaticon-polls',
      title: title,
      image: image,
      contentType: 'Certified Course',
      id: type_id,
      fallbackImage: default_images.training,
      onClick: () => redirectTo('TrainingContent', type_id, title)
    };
  } else if (type == 'session') {
    return {
      internalType: 'session',
      type_id: data?.session_id,
      icon: 'flaticon-livecme',
      title: data?.session_topic,
      image: data?.cover_image,
      contentType: 'Live CME',
      id: data?.session_id,
      fallbackImage: default_images.session,
      onClick: () => redirectTo('SessionDetails', data?.session_id, data?.session_topic)
    };
  } else if (type == 'epub') {
    return {
      internalType: 'epub',
      type_id: data?.type_id,
      icon: 'flaticon-ebook',
      title: data?.title,
      image: data?.image,
      contentType: 'E-Paper',
      id: data?.type_id,
      fallbackImage: default_images.epub,
      onClick: () => redirectTo('EbookDetails', data?.type_id, data?.title)
    };
  }
};
